import React, { useEffect, useState } from 'react'
import { Col, Row, Input, Select, Button, List, message, Spin, Typography, Drawer, Divider } from 'antd'
import UISpinner from '../../../../components/UISpinner'
import inventorySrc from '../../../inventory/inventorySrc'

const { Title } = Typography

// Modal de productos sugeridos.
function SuggestedProductsList(props) {

    const [dataSource, setDataSource] = useState([])
    const [suggested, setSuggested] = useState([])
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if (props.visible) {
            setSuggested([])
        }
    }, [props.visible])

    useEffect(() => {
        setDataSource(props.suggestedProducts)

        if (Object.keys(suggested).length > 0) {
            props.setDataSource(suggested)
        }
    }, [props.suggestedProducts, suggested])

    const addProduct = (row) => {
        if (row.units <= 0) {
            message.warning('Debe ingresar una cantidad')
            return
        }

        let stock = 0

        // Filtrar los objetos que tienen `product: null`
        const filteredDataSource = props.dataSource.filter(item => item.product !== null);

        // Buscar si el producto ya existe en el array
        const existingProductIndex = filteredDataSource.findIndex(item => item.product_id === row.product_id);

        const existingOriginalIndex = filteredDataSource.findIndex(item => item.no_stock === row.no_stock);

        // Si el producto ya existe, eliminarlo del array
        if (existingProductIndex !== -1) {
            message.error('El producto ya está agregado en la lista')
            return
        }

        if (existingOriginalIndex !== -1) {
            message.error('Solo puede agregar un producto sugerido a la lista')
            return
        }

        setLoading(true)

        inventorySrc
            .getInventory(props.storeId, false, '', false, false, 'desc', row.product_id)
            .then(res => {
                if (res?.data.length === 0) {
                    message.warning('No existe este producto para esta tienda')
                } else {
                    stock = parseFloat(res?.data[0].quantity)
                }
                setLoading(false)

                if (stock < parseFloat(row.units)) {
                    message.error('No hay suficientes existencias')
                    return
                }

                // Agregar el nuevo objeto al array
                const updatedDataSource = [...filteredDataSource, row];

                // Renumerar los ids de todos los objetos en el array actualizado
                const renumberedDataSource = updatedDataSource.map((item, index) => ({
                    ...item,
                    id: index + 1  // Asignar el id desde 1 hasta N (index + 1)
                }));

                // Actualizar con los objetos renumerados
                setSuggested(renumberedDataSource);
            })
            .catch(e => {
                console.log(e);
                
                message.error('No se ha podido cargar el inventario.')
                setLoading(false)
            })

    };

    const onSetData = (e, rowId, name, product = false) => {
        const inputName = name ? name : e.target.name
        const value = name ? e : e.target.value
        let newRow
        if (product) {
            if (name === 'discount_id') {
                newRow = {
                    [inputName]: value
                }
            } else {
                newRow = {
                    [inputName]: value,
                    units: 1,
                }
            }

        } else {
            newRow = { [inputName]: value }
        }

        const newDataSource = dataSource.map(row => {
            if (row.id === rowId) {
                return Object.assign(row, newRow)
            }
            return row
        })
        setDataSource(newDataSource)
    }

    const onSetPrice = (e, row) => {
        onSetData(e, row.id)
        if (row.discount_id) {
            const presentationInfo = row.presentation.find(element => element.id === row.discount_id);
            onSetData(presentationInfo?.id, row.id, 'discount_id')
            const porcentaje = presentationInfo.pivot.discount_amount
            const priceUnits = row.price * (row.units !== '' ? row.units : 0)
            // const priceRes = ((porcentaje * priceUnits) / 100)
            const price = priceUnits - porcentaje * row.units

            onSetData(price, row.id, 'total')
        } else {
            onSetData(row.price * (row.units !== '' ? row.units : 0), row.id, 'total')
        }
    }

    const onSetUnits = (e, row) => {
        onSetData(e, row.id)

        if (row.discount_id) {
            const presentationInfo = row.presentation.find(element => element.id === row.discount_id);
            onSetData(presentationInfo?.id, row.id, 'discount_id')

            const porcentaje = presentationInfo.pivot.discount_amount
            const priceUnits = row.price * (row.units !== '' ? row.units : 0)
            // const priceRes = ((porcentaje * priceUnits) / 100)
            const price = priceUnits - porcentaje * row.units

            onSetData(price, row.id, 'total')
        } else {
            onSetData(row.price * (row.units !== '' ? row.units : 0), row.id, 'total')
        }
    }

    const onCancel = () => {
        props.closable()
    }

    function trunc(x, decimalDigits = 2, returnText = true, longFixed = true) {
        x = Number(x);
        decimalDigits = Number(decimalDigits);

        x = x * (10 ** decimalDigits);
        x = x - x % 1;
        x = x / (10 ** decimalDigits);

        if (returnText)
            if (longFixed)
                return x.toFixed(decimalDigits);
            else
                return x.toString();
        else
            return x;
    }

    return (
        <>
            <Drawer placement="right" closable={false} onClose={props.closable} visible={props.visible} width={800}>
                {props.loading && (
                    <div className="loading-spinner">
                        <UISpinner />
                    </div>
                )}
                <div>
                    <Title> Productos Sugeridos </Title>
                    <Divider className={'divider-custom-margins-users'} />
                    <List
                        id={'inventory-list'}
                        size="small"
                        rowKey="id"
                        dataSource={dataSource}
                        renderItem={(row, i) => (
                            <>
                                {/* Si es el primer producto o si el producto anterior tiene un no_stock diferente */}
                                {(i === 0 || dataSource[i - 1].no_stock !== row.no_stock) && (
                                    <>
                                        <Row gutter={24} align="bottom" className={'section-space-field w-100'} key={row.id}>
                                            <Col sm={24}>
                                                <div className={'title-space-field pl-2'}>Producto sin existencias: {row.no_stock} </div>
                                            </Col>
                                        </Row>
                                    </>
                                )}

                                {/* Fila de productos sugeridos */}
                                <List.Item>
                                    <Row gutter={24} align="bottom" className={'section-space-field w-100'} key={row.id}>
                                        <Col sm={1}>
                                            <div className={'title-space-bottom text-bold'}>{i + 1}</div>
                                        </Col>
                                        <Col sm={9}>
                                            {i === 0 && <div className={'title-space-field pl-2'}>Sugerido</div>}
                                            <Input
                                                value={row.description}
                                                name={'product'}
                                                size={'large'}
                                                min="0"
                                            />
                                        </Col>
                                        <Col sm={4}>
                                            {i === 0 && <div className={'title-space-field text-center'}>Precio Unitario</div>}
                                            <Input
                                                disabled={true}
                                                value={row.price}
                                                onChange={e => onSetPrice(e, row)}
                                                placeholder={'Precio'}
                                                name={'price'}
                                                size={'large'}
                                                min="0"
                                            />
                                        </Col>
                                        <Col sm={4}>
                                            {i === 0 && <div className={'title-space-field text-center'}>No. Unidades</div>}
                                            <Input
                                                disabled={true}
                                                value={row.units}
                                                onChange={e => onSetUnits(e, row)}
                                                placeholder={'No. Unidades'}
                                                name={'units'}
                                                size={'large'}
                                                min="0"
                                            />
                                        </Col>
                                        <Col sm={3}>
                                            {i === 0 && <div className={'title-space-field text-center'}>Total</div>}
                                            <Input
                                                style={{ textAlign: 'center' }}
                                                disabled={true}
                                                value={trunc(row.total)}
                                                placeholder={'Q 0.00'}
                                                name={'total'}
                                                size={'large'}
                                                min="0"
                                                className="total-product"
                                            />
                                        </Col>
                                        <Col sm={3} className={'center-flex-div'}>
                                            <Button loading={loading} className="title-tendero new-button" onClick={() => addProduct(row)}>
                                                Agregar
                                            </Button>
                                        </Col>
                                    </Row>
                                </List.Item>
                                {(i === dataSource.length - 1 || dataSource[i + 1].no_stock !== row.no_stock) && <Divider className={'divider-custom-margins-users'} />}
                            </>
                        )}
                    />

                </div>

                <div>
                    <Divider className={'divider-custom-margins-users'} />
                    <Row gutter={16}>
                        <Col xs={24} sm={24} md={24} lg={24}>
                            <div className="text-right">
                                <div>
                                    <Button loading={props.loading} type={'link'} className="cancel-button" onClick={() => onCancel()}>
                                        Cancelar
                                    </Button>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </Drawer>
        </>
    )
}

export default SuggestedProductsList
